import { render } from "./ActionsView.vue?vue&type=template&id=38d7661f"
import script from "./ActionsView.vue?vue&type=script&lang=js"
export * from "./ActionsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__